import type { FC } from "react";
import type { ProductHistoricalInsights } from "../historical-insights.types";
import { formatSnakeCase } from "../insights-utils";

interface Props {
  outcomes: ProductHistoricalInsights["outcomes"];
}

export const InsightsOutcomesSection: FC<Props> = ({ outcomes }) => {
  const lossEntries = Object.entries(outcomes.lossReasons);
  const hasData = outcomes.winFactors.length > 0 || lossEntries.length > 0 || outcomes.competitiveFactors.length > 0;

  if (!hasData) {
    return null;
  }

  return (
    <div className="space-y-3">
      <h3 className="text-sm font-semibold">Outcomes</h3>

      {outcomes.winFactors.length > 0 && (
        <div>
          <h4 className="text-xs font-medium text-muted-foreground mb-1">Win Factors</h4>
          <ul className="list-disc list-inside text-xs space-y-0.5">
            {outcomes.winFactors.map((factor, i) => (
              <li key={i}>{factor}</li>
            ))}
          </ul>
        </div>
      )}

      {lossEntries.length > 0 && (
        <div>
          <h4 className="text-xs font-medium text-muted-foreground mb-1">Loss Reasons</h4>
          <div className="space-y-1">
            {lossEntries.map(([reason, count]) => (
              <div key={reason} className="flex justify-between text-xs">
                <span>{formatSnakeCase(reason)}</span>
                <span className="text-muted-foreground">{count}</span>
              </div>
            ))}
          </div>
        </div>
      )}

      {outcomes.competitiveFactors.length > 0 && (
        <div>
          <h4 className="text-xs font-medium text-muted-foreground mb-1">Competitive Factors</h4>
          <ul className="list-disc list-inside text-xs space-y-0.5">
            {outcomes.competitiveFactors.map((factor, i) => (
              <li key={i}>{factor}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};
